export default function number(x) {
  return x === null ? NaN : +x;
}

export function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/number.js
// module id = 162
// module chunks = 0